'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('survey-form', {
      url: '/survey-form/:id/:propertyId/:contactId/:emailHash',
      template: '<survey-form></survey-form>'
    });
}



// WEBPACK FOOTER //
// ./client/app/survey/form/survey-form.routes.js